
import React, { useEffect, useState } from 'react';

const SimonSays = () => {
  const [command, setCommand] = useState('');

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = 'en-US';

    recognition.onresult = (event) => {
      let finalTranscript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      if (finalTranscript) {
        setCommand(finalTranscript);
      }
    };

    recognition.start();
    return () => recognition.stop();
  }, []);

  return (
    <div>
      <h2>JM Says</h2>
      <p>Say something!</p>
      <p>{command}</p>
    </div>
  );
};

export default SimonSays;

